import { Link } from "react-router-dom";
import styled from "styled-components";
import menuIcon from "../../Assets/menuIcon.svg";

export const Container = styled.div`
  position: fixed;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
`;

export const NavigationBar = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 245px;
  padding: 5px;
  border-radius: 8px;
  background-color: var(--primary-color-with-transparency);

  @media (min-width: 1024px) {
    display: none;
  }
`;

export const Button = styled.button`
  width: 50px;
  height: 27px;
  background-size: contain;
  background-image: url(${menuIcon});
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
  border: none;
  text-align: center;
  transition: 500ms;
  &.show {
    margin-bottom: 1rem;
    transform: rotateX(180deg);
    transition: 600ms;
  }
`;
export const Page = styled(Link)`
  width: 100%;
  text-align: center;
  line-height: 2rem;

  :nth-child(2) {
    border-top: 1px solid var(--secondary-color);
  }
  color: var(--secondary-color);
  border-bottom: 1px solid var(--secondary-color);
  :link {
    text-decoration: none;
  }
  :hover {
    color: var(--tertiary-color-main-buttons);
    font-weight: bold;
  }
  &.unitHabits,
  &.guests,
  &.products_services,
  &.colaborators,
  &.dashboard,
  &.login,
  &.about_us {
    color: var(--tertiary-color-main-buttons);
    font-weight: bold;
  }
`;
